import { webApiClient } from 'tradera/utils/http';

export const getInvoice = (invoiceId) =>
    webApiClient.get('/mytradera/invoicecheckout', {
        params: {
            invoiceId
        },
        withCredentials: true
    });

export const getPaymentOptions = async (invoiceId) =>
    webApiClient.get(
        `/mytradera/invoicecheckout/invoicepaymentoptions/${invoiceId}`
    );

export const initializePayment = async (formData) =>
    webApiClient.post(
        '/mytradera/invoicecheckout/initializeinvoicepaymentattempt',
        formData
    );

export const getPaymentStatus = async (paymentAttemptId) =>
    webApiClient.get(
        `/mytradera/invoicecheckout/invoicepaymentattemptstatus/${paymentAttemptId}`
    );

export const completePayment = async (formData) =>
    webApiClient.post(
        '/mytradera/invoicecheckout/completeinvoicepaymentattempt',
        formData
    );

export const cancelPayment = async (formData) =>
    webApiClient.post(
        '/mytradera/invoicecheckout/cancelinvoicepaymentattempt',
        formData
    );

export const getExternalAuthData = async (paymentAttemptId) =>
    webApiClient.get(
        `/mytradera/invoicecheckout/invoicepaymentattemptauthenticationdata/${paymentAttemptId}`
    );

export const getBraintreeToken = async ({ invoiceId, paymentOption }) =>
    webApiClient.get(
        `/mytradera/invoicecheckout/invoicebraintreeclienttoken/${invoiceId}`,
        {
            params: {
                paymentMethod: paymentOption
            },
            withCredentials: true
        }
    );

// Export object for Sinon stubbing
export default {
    getInvoice,
    getPaymentOptions,
    initializePayment,
    getPaymentStatus,
    completePayment,
    cancelPayment,
    getExternalAuthData,
    getBraintreeToken
};
